import { render, staticRenderFns } from "./PreviewForm4.vue?vue&type=template&id=ad17c43c&scoped=true"
import script from "./PreviewForm4.vue?vue&type=script&lang=ts"
export * from "./PreviewForm4.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad17c43c",
  null
  
)

export default component.exports